import React, { useEffect, useState } from "react";
import { Button, Card, Table, Tabs } from "antd";
import "./ManageInstructorForm.scss";
import Buttons from "../../../Components/Buttons/Buttons";
import FormInputs from "../../../Components/FormInputs/FormInputs";
import TextArea from "antd/es/input/TextArea";
import { LeftCircleOutlined } from "@ant-design/icons";
import SelectInputs from "../../../Components/SelectInputs/SelectInputs";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getApi, postApi } from "../../../Utlis/apiService";
import {
  GET_ALL_INSTRUCTORS,
  GET_ASSIGNED_CLASSES,
  GET_INSTRUCTOR_SLOTS,
  UPDATE_INSTRUCTOR_SLOTS,
  UPDATE_INSTRUCTORS,
  GET_CATEGORY_DROPDOWN,
  GET_INSTRUCTOR_BANK_DETAILS,
  GET_INSTRUCTOR_PROFILE,
} from "../../../Utlis/apiPath";
import { errorToast, successToast } from "../../../Services/ToastHelper";
import Loader from "../../../Components/Loader/Loader";
import { BackArrowIcon } from "../../../Components/Icons/BackArrowIcon";
import { useNavigate, useParams } from "react-router-dom";
import MultiSelectInput from "../../../Components/MultiSelectInput/MultiSelectInput";
import WeeklySchedule from "../../../Components/InstructorWeeklySchedule/WeeklySchedule";

const { TabPane } = Tabs;

const buildEmptySchedule = () => ({
  Monday: {
    isActive: false,
    onlineActive: false,
    offlineActive: false,
    online: [{ start: null, end: null, slotType: 1 }],
    offline: [{ start: null, end: null, slotType: 2 }],
  },
  Tuesday: {
    isActive: false,
    onlineActive: false,
    offlineActive: false,
    online: [{ start: null, end: null, slotType: 1 }],
    offline: [{ start: null, end: null, slotType: 2 }],
  },
  Wednesday: {
    isActive: false,
    onlineActive: false,
    offlineActive: false,
    online: [{ start: null, end: null, slotType: 1 }],
    offline: [{ start: null, end: null, slotType: 2 }],
  },
  Thursday: {
    isActive: false,
    onlineActive: false,
    offlineActive: false,
    online: [{ start: null, end: null, slotType: 1 }],
    offline: [{ start: null, end: null, slotType: 2 }],
  },
  Friday: {
    isActive: false,
    onlineActive: false,
    offlineActive: false,
    online: [{ start: null, end: null, slotType: 1 }],
    offline: [{ start: null, end: null, slotType: 2 }],
  },
  Saturday: {
    isActive: false,
    onlineActive: false,
    offlineActive: false,
    online: [{ start: null, end: null, slotType: 1 }],
    offline: [{ start: null, end: null, slotType: 2 }],
  },
  Sunday: {
    isActive: false,
    onlineActive: false,
    offlineActive: false,
    online: [{ start: null, end: null, slotType: 1 }],
    offline: [{ start: null, end: null, slotType: 2 }],
  },
});

const initialValues = {
  firstName: "",
  lastName: "",
  emailId: "",
  mobileNumber: "",
  countryCode: "",
  aboutMe: "",
  gender: "",
  education: "",
  experience: "",
  expertise: "",
  registrationFee: "",
  securityFee: "",
  expectedPerSessionFee: "",
  finalPerSessionFee: "",
  bankAccountNumber: "",
  reEnterBankAccountNumber: "",
  ifscCode: "",
  bankName: "",
  branchName: "",
  accountHolderName: "",
  upiId: "",
};

const ManageInstructorForm = ({ setShowAddInstructorForm, fetchTableData }) => {
  const [formData, setFormData] = useState(initialValues);
  const [selectedValue, setSelectedValue] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const Navigate = useNavigate();
  const [updateData, setUpdateData] = useState();
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isApproved, setIsApproved] = useState(true);
  const [isDenied, setIsDenied] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const { id } = useParams();
  const [assignedClasses, setAssignedClasses] = useState();
  const [assignedTotal, setAssignedTotal] = useState(0);
  const [assignedPageIndex, setAssignedPageIndex] = useState(0); // 0-based for API
  const [assignedPageSize, setAssignedPageSize] = useState(10);
  const [removedIds, setRemovedIds] = useState([]);
  const [removedSlotIds, setRemovedSlotIds] = useState([]);
  const [newlyAddedSlots, setNewlyAddedSlots] = useState([]);
  const [phoneValue, setPhoneValue] = useState();
  const [selectedCategory, setSelectedCategory] = useState();
  const [activeTab, setActiveTab] = useState(0);
  // Add state for profile data
  const [profileData, setProfileData] = useState({
    totalOnlineBookings: 0,
    totalOfflineBookings: 0,
    totalOnlineEarnings: 0,
    totalOfflineEarnings: 0,
    totalEarnings: 0,
    bookingsBreakdown: [],
  });

  const [schedule, setSchedule] = useState(buildEmptySchedule);
  const [daylightSchedule, setDaylightSchedule] = useState(buildEmptySchedule);
  const [newlyAddedDaylightSlots, setNewlyAddedDaylightSlots] = useState([]);

  const [prevSchedule, setPrevSchedule] = useState(schedule);

  // ... (keep all existing useEffect hooks and functions until the fetchInstructorBankDetails function)

  useEffect(() => {
    const newRemovedIds = [];
    Object.keys(schedule).forEach((day) => {
      const currentSlots = schedule[day].slots;
      const previousSlots = prevSchedule[day]?.slots || [];

      const removedIds = previousSlots.filter(
        (id) => !currentSlots.includes(id)
      );
      newRemovedIds.push(...removedIds);
    });
    if (newRemovedIds.length > 0) {
      setRemovedIds((prev) => [...prev, ...newRemovedIds]);
    }
    setPrevSchedule(schedule);
  }, [schedule]);

  const patchFormData = (updateData) => {
    const updatedValues = {
      firstName: updateData.firstName || "",
      lastName: updateData.lastName || "",
      emailId: updateData.mailId || "",
      mobileNumber: updateData.mobileNo || "",
      countryCode: updateData.countryCode || "+1",
      aboutMe: updateData.aboutMe || "",
      gender: updateData.gender || "",
      education: updateData.education || "",
      experience: updateData.experience || "",
      expertise: updateData.expertise || "",
      registrationFee: updateData.registrationFee || "",
      securityFee: updateData.securityFee || "",
      expectedPerSessionFee: updateData.expectedPerSessionFee || "",
      finalPerSessionFee: updateData.finalPerSessionFee || "",
    };

    setFormData((prevState) => ({
      ...prevState,
      ...updatedValues,
    }));
  };

  useEffect(() => {
    setPhoneValue(`${formData.countryCode}${formData.mobileNumber}`);
  }, [formData.countryCode, formData.mobileNumber]);

  useEffect(() => {
    handleManageInstructor(id);
  }, [id]);

  const handleManageInstructor = async (id) => {
    setIsLoading(true);
    try {
      const response = await getApi(GET_ALL_INSTRUCTORS, {
        params: {
          instructorId: id,
          pageIndex,
          pageSize,
          search: searchTerm,
          isApproved,
          isDenied,
        },
      });

      if (response.status === 200) {
        setUpdateData(response.data?.instructors || []);
        setTotalRecords(response.data?.totalRecords);
      } else if (response.status === 404) {
        setTotalRecords(0);
        console.warn("No data found for the given criteria.");
      }
    } catch (error) {
      console.error("Error fetching table data:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInstructorSlots(id, "standard", setSchedule);
    fetchInstructorSlots(id, "daylight", setDaylightSchedule);
  }, [id, activeTab]);

  const patchScheduleData = (slotsData, targetSetSchedule) => {
    const newSchedule = buildEmptySchedule();

    slotsData.forEach(({ day, slotType, id, startTime, endTime }) => {
      if (!newSchedule[day]) return;

      const mode = slotType === 1 ? "online" : "offline";

      // Mark the day as active
      newSchedule[day].isActive = true;
      if (mode === "online") newSchedule[day].onlineActive = true;
      if (mode === "offline") newSchedule[day].offlineActive = true;

      // If the only entry is the placeholder {start:null,end:null}, remove it
      if (
        newSchedule[day][mode].length === 1 &&
        newSchedule[day][mode][0].start === null
      ) {
        newSchedule[day][mode] = [];
      }

      // Push actual slot
      newSchedule[day][mode].push({
        id,
        start: startTime,
        end: endTime,
        slotType,
        isPatched: true,
      });
    });

    // Sort slots by start time for each day and mode
    Object.keys(newSchedule).forEach((day) => {
      ["online", "offline"].forEach((mode) => {
        newSchedule[day][mode].sort((a, b) => {
          if (!a.start || !b.start) return 0;
          return a.start.localeCompare(b.start);
        });
      });
    });

    targetSetSchedule(newSchedule);
  };

  const fetchInstructorSlots = async (id, mode, targetSetSchedule) => {
    setIsLoading(true);
    const params = {
      instructorId: id,
      mode,
    };
    const { status, data } = await getApi(GET_INSTRUCTOR_SLOTS, {
      params,
    });
    if (status === 200) {
      patchScheduleData(data, targetSetSchedule);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryDropDown();
  }, []);

  const fetchCategoryDropDown = async () => {
    setIsLoading(true);
    try {
      const url = `${GET_CATEGORY_DROPDOWN}`;
      const { status, message, data } = await getApi(url);
      if (status === 200) {
        setSelectedCategory(data);
      } else {
        setSelectedCategory([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      setSelectedCategory([]);
    } finally {
      setIsLoading(false);
    }
  };

  const UpdateInstructorSlots = async (id) => {
    setIsLoading(true);

    try {
      const payload = {
        instructorId: id,
        slots: newlyAddedSlots,
        prevSlotIds: removedSlotIds,
        mode: "standard",
      };

      const { status } = await postApi(UPDATE_INSTRUCTOR_SLOTS, payload);

      if (newlyAddedDaylightSlots.length > 0 || removedSlotIds.length > 0) {
        await postApi(UPDATE_INSTRUCTOR_SLOTS, {
          instructorId: id,
          slots: newlyAddedDaylightSlots,
          prevSlotIds: removedSlotIds,
          mode: "daylight",
        });
      }

      if (status === 200) {
        setNewlyAddedSlots([]);
        setNewlyAddedDaylightSlots([]);
        setRemovedSlotIds([]);
      }
    } catch (error) {
      console.error("Error updating instructor slots:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    handleAssignedClasses(id, assignedPageIndex, assignedPageSize);
  }, [id, assignedPageIndex, assignedPageSize]);

  const handleAssignedClasses = async (
    id,
    pageIndexParam = 0,
    pageSizeParam = 10
  ) => {
    setIsLoading(true);
    const params = {
      instructorId: id,
      pageIndex: pageIndexParam,
      pageSize: pageSizeParam,
    };
    const { status, data } = await getApi(GET_ASSIGNED_CLASSES, {
      params,
    });
    if (status === 200) {
      setAssignedClasses(data?.classes || []);
      setAssignedTotal(data?.totalRecords || 0);
    } else {
      setAssignedClasses([]); // Set empty array for any non-200 status
      setAssignedTotal(0);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (updateData?.length > 0) {
      patchFormData(updateData[0]);
    }
  }, [updateData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const findIncompleteSlot = (scheduleObj) => {
    for (const day of Object.keys(scheduleObj)) {
      const dayData = scheduleObj[day];
      for (const mode of ["online", "offline"]) {
        const slots = dayData[mode] || [];
        for (const slot of slots) {
          if (Boolean(slot.start) !== Boolean(slot.end)) {
            return { day, mode };
          }
        }
      }
    }
    return null;
  };

  const deriveNewlyAddedSlots = (scheduleObj) =>
    Object.entries(scheduleObj).reduce((acc, [day, dayData]) => {
      const combinedSlots = [];

      // ✅ handle online slots
      if (dayData.online?.length > 0) {
        const newOnlineSlots = dayData?.online?.filter(
          (slot) => !slot.isPatched && slot.start && slot.end
        );
        if (newOnlineSlots.length > 0) {
          combinedSlots.push(
            ...newOnlineSlots.map((slot) => ({
              startTime: slot.start,
              endTime: slot.end,
              slotType: 1,
            }))
          );
        }
      }

      // ✅ handle offline slots
      if (dayData.offline?.length > 0) {
        const newOfflineSlots = dayData?.offline?.filter(
          (slot) => !slot.isPatched && slot.start && slot.end
        );
        if (newOfflineSlots.length > 0) {
          combinedSlots.push(
            ...newOfflineSlots.map((slot) => ({
              startTime: slot.start,
              endTime: slot.end,
              slotType: 2,
            }))
          );
        }
      }

      if (combinedSlots.length > 0) {
        acc.push({
          days: day,
          startEndTime: combinedSlots,
        });
      }

      return acc;
    }, []);

  useEffect(() => {
    setNewlyAddedSlots(deriveNewlyAddedSlots(schedule));
  }, [schedule]);

  useEffect(() => {
    setNewlyAddedDaylightSlots(deriveNewlyAddedSlots(daylightSchedule));
  }, [daylightSchedule]);

  const handlePhoneChange = (value, country) => {
    setFormData({
      ...formData,
      mobileNumber: value.slice(country.dialCode.length),
      countryCode: `+${country.dialCode}`,
    });
  };

  const validateFields = () => {
    let errObj = {};

    if (!formData?.firstName.trim()) {
      errObj.firstName = "First Name is required";
    }
    if (!formData?.lastName.trim()) {
      errObj.lastName = "Last Name is required";
    }
    if (!formData?.emailId.trim()) {
      errObj.emailId = "Email is required";
    } else if (/\s/.test(formData?.emailId)) {
      errObj.emailId = "Email should not contain spaces";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData?.emailId)) {
      errObj.emailId = "Please enter a valid email address";
    }
    if (!formData?.mobileNumber.trim()) {
      errObj.mobileNumber = "Mobile Number is required";
    }
    if (!formData?.gender.trim()) {
      errObj.gender = "Gender is required";
    }
    if (!formData?.education.trim()) {
      errObj.education = "Education is required";
    }
    if (!formData.experience && formData.experience !== 0) {
      errObj.experience = "Experience is required";
    }
    if (!formData.registrationFee) {
      errObj.registrationFee = "Registration Fee is required";
    } else if (
      isNaN(formData.registrationFee) ||
      formData.registrationFee <= 0
    ) {
      errObj.registrationFee = "Please enter a valid Registration Fee";
    }
    if (
      formData.securityFee &&
      (isNaN(formData.securityFee) || formData.securityFee < 0)
    ) {
      errObj.securityFee = "Please enter a valid Security Fee";
    }
    if (
      formData.expectedPerSessionFee &&
      (isNaN(formData.expectedPerSessionFee) ||
        formData.expectedPerSessionFee <= 0)
    ) {
      errObj.expectedPerSessionFee =
        "Please enter a valid Expected Per Session Fee";
    }
    if (
      formData.finalPerSessionFee &&
      (isNaN(formData.finalPerSessionFee) || formData.finalPerSessionFee <= 0)
    ) {
      errObj.finalPerSessionFee =
        "Please enter a valid Approved Per Session Fee";
    }

    const isValid = Object.keys(errObj).length === 0;

    setErrors(errObj);
    return isValid;
  };

  const handleUpdate = async () => {
    if (validateFields()) {
      const incompleteSlot =
        findIncompleteSlot(schedule) || findIncompleteSlot(daylightSchedule);
      if (incompleteSlot) {
        errorToast(
          `Please enter both start and end time for the ${incompleteSlot.mode} slot on ${incompleteSlot.day}, or clear it.`
        );
        return;
      }

      const payload = {
        instructorId: updateData[0]?.instructorId,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.emailId,
        countryCode: formData.countryCode,
        phoneNumber: formData.mobileNumber,
        gender: formData.gender,
        aboutMe: formData.aboutMe,
        education: formData.education,
        experienceYears: formData.experience,
        experties: Array.isArray(formData.expertise)
          ? formData.expertise.map(Number)
          : [],
        registrationFee: parseFloat(formData.registrationFee),
        securityFee: parseFloat(formData.securityFee),
        expectedPerSessionFee: formData.expectedPerSessionFee
          ? parseFloat(formData.expectedPerSessionFee)
          : undefined,
        finalPerSessionFee: formData.finalPerSessionFee
          ? parseFloat(formData.finalPerSessionFee)
          : undefined,
      };
      setIsLoading(true);
      try {
        const { status, message } = await postApi(UPDATE_INSTRUCTORS, payload);
        if (status === 200) {
          Navigate("/instructor");
          UpdateInstructorSlots(id);
          handleManageInstructor(id);
          successToast(message);
        } else {
          errorToast(message);
        }
      } catch (error) {
        console.error("Error adding instructor:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const hanldeBack = () => {
    Navigate("/instructor");
  };

  function mapExpertiseNamesToIds(categories, expertiseNames) {
    if (!Array.isArray(categories) || !Array.isArray(expertiseNames)) return [];
    return categories
      .filter((cat) => expertiseNames.includes(cat.name))
      .map((cat) => Number(cat.id));
  }

  useEffect(() => {
    if (selectedCategory && updateData && updateData.length > 0) {
      const expertiseIds = mapExpertiseNamesToIds(
        selectedCategory,
        updateData[0].expertise || []
      );
      setFormData((prev) => ({ ...prev, expertise: expertiseIds }));
    }
  }, [selectedCategory, updateData]);

  const categoryOptions =
    selectedCategory?.map((category) => ({
      label: category.name.trim(),
      value: Number(category.id),
    })) || [];

  const fetchInstructorBankDetails = async (id) => {
    setIsLoading(true);
    try {
      const response = await getApi(GET_INSTRUCTOR_BANK_DETAILS, {
        params: { instructorId: id },
      });

      if (response && response.status === 200 && response.data) {
        const bankDetails = response.data;

        setFormData((prevState) => ({
          ...prevState,
          bankAccountNumber: bankDetails.accountNumber || "",
          reEnterBankAccountNumber: bankDetails.accountNumber || "",
          ifscCode: bankDetails.ifscCode || "",
          branchName: bankDetails.branchName || "",
          accountHolderName: bankDetails.bankHolderName || "",
          upiId: bankDetails.upiId || "",
        }));
      } else if (response.status === 403) {
        console.warn("Access denied for bank details");
        errorToast("You do not have permission to view bank details");

        setFormData((prevState) => ({
          ...prevState,
          bankAccountNumber: "Access Restricted",
          reEnterBankAccountNumber: "Access Restricted",
          ifscCode: "Access Restricted",
          branchName: "Access Restricted",
          accountHolderName: "Access Restricted",
          upiId: "Access Restricted",
        }));
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
      errorToast("Failed to load bank details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Add new function to fetch instructor profile data
  const fetchInstructorProfile = async (id) => {
    setIsLoading(true);
    try {
      const response = await getApi(GET_INSTRUCTOR_PROFILE, {
        params: { instructorId: id },
      });

      if (response && response.status === 200 && response.data) {
        setProfileData({
          totalOnlineBookings: response.data.totalOnlineBookings || 0,
          totalOfflineBookings: response.data.totalOfflineBookings || 0,
          totalOnlineEarnings: response.data.totalOnlineEarnings || 0,
          totalOfflineEarnings: response.data.totalOfflineEarnings || 0,
          totalEarnings: response.data.totalEarnings || 0,
          bookingsBreakdown: response.data.bookingsBreakdown || [],
        });
      } else {
        console.warn("Failed to fetch instructor profile data");
      }
    } catch (error) {
      console.error("Error fetching instructor profile:", error);
      errorToast("Failed to load profile data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleTabChange = (activeKey) => {
    if (activeKey === "2" && id) {
      // Assigned Classes tab - data is already fetched via useEffect
      // No additional action needed as data is already loaded
    } else if (activeKey === "3" && id) {
      fetchInstructorBankDetails(id);
    } else if (activeKey === "4" && id) {
      fetchInstructorProfile(id);
    }
  };

  const handleDeleteSlot = (slotId) => {
    setRemovedSlotIds((prev) =>
      prev.includes(slotId) ? prev : [...prev, slotId]
    );
  };

  // Helper function to format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Helper function to get breakdown data by type
  const getBreakdownData = (type) => {
    const breakdown = profileData.bookingsBreakdown.find(
      (item) => item.type?.toLowerCase() === type.toLowerCase()
    );
    return breakdown?.count || 0;
  };

  // Define columns for assigned classes table
  const assignedClassesColumns = [
    {
      title: "Sl. No",
      dataIndex: "slNo",
      key: "slNo",
    },
    {
      title: "Class Name",
      dataIndex: "className",
      key: "className",
    },
    {
      title: "Class Type",
      dataIndex: "classType",
      key: "classType",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Booking Capacity",
      dataIndex: "capacity",
      key: "capacity",
      align: "center",
    },
    {
      title: "Mode",
      dataIndex: "mode",
      key: "mode",
    },
  ];

  // Format assigned classes data for table
  const assignedClassesData = assignedClasses?.map((item, index) => ({
    key: item.id,
    slNo: assignedPageIndex * assignedPageSize + index + 1,
    className: item.name,
    classType: item.classType,
    time: item.duration,
    capacity: item.capacity,
    mode: item.mode,
  }));

  return (
    <div className="Manageinstructor">
      <div className="instform">
        {isLoading && <Loader />}
        <div className="instform_header">
          <h2
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
            onClick={hanldeBack}
          >
            <BackArrowIcon />
            Instructor
          </h2>
        </div>

        <Tabs defaultActiveKey="1" onChange={handleTabChange}>
          <TabPane tab="Personal Information" key="1">
            <div className="instform_content">
              <div className="instform_content_details"></div>
              <div className="instform_wrapper">
                <div className="instform_content_details">
                  <div className="instform_content_details_top">
                    <div className="form_field">
                      <FormInputs
                        title="First Name"
                        placeholder="Enter First Name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                      {errors.firstName && (
                        <span className="error">{errors.firstName}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <FormInputs
                        title="Last Name"
                        placeholder="Enter Last Name"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                      {errors.lastName && (
                        <span className="error">{errors.lastName}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <FormInputs
                        title="Email Id"
                        placeholder="Enter Email Id"
                        name="emailId"
                        value={formData.emailId}
                        onChange={handleChange}
                      />
                      {errors.emailId && (
                        <span className="error">{errors.emailId}</span>
                      )}
                    </div>
                    <div className="form_field phone-input-container">
                      <label>Mobile Number</label>
                      <PhoneInput
                        country={"in"}
                        value={phoneValue}
                        onChange={handlePhoneChange}
                        inputStyle={{
                          width: "100%",
                          borderRadius: "5px",
                          borderColor: "#d9d9d9",
                        }}
                      />
                      {errors.mobileNumber && (
                        <span className="error">{errors.mobileNumber}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="instform_content_textarea">
                  <label htmlFor="notes">About</label>
                  <TextArea
                    id="notes"
                    placeholder="Enter notes here"
                    rows={4}
                    name="aboutMe"
                    value={formData.aboutMe}
                    onChange={handleChange}
                    style={{
                      fontWeight: 600,
                      color: "#717171",
                      fontSize: "16px",
                    }}
                  />
                </div>
                <div className="instform_content_details">
                  <div className="instform_content_details_top">
                    <div className="form_field">
                      <SelectInputs
                        title="Gender"
                        name="gender"
                        placeholder="Select Gender"
                        options={[
                          { label: "Male", value: "Male" },
                          { label: "Female", value: "Female" },
                        ]}
                        value={
                          formData.gender?.slice(0, 1).toUpperCase() +
                          formData.gender?.slice(1)
                        }
                        onChange={(value) =>
                          setFormData({ ...formData, gender: value })
                        }
                        size="large"
                        style={{ width: "100%" }}
                      />
                      {errors.gender && (
                        <span className="error">{errors.gender}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <FormInputs
                        title="Education"
                        placeholder="Enter Education"
                        name="education"
                        value={formData.education}
                        onChange={handleChange}
                      />
                      {errors.education && (
                        <span className="error">{errors.education}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <FormInputs
                        type="number"
                        title="Experience"
                        placeholder="Enter Experience"
                        name="experience"
                        value={formData?.experience}
                        onChange={handleChange}
                      />
                      {errors.experience && (
                        <span className="error">{errors.experience}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <MultiSelectInput
                        title="Expertise*"
                        options={categoryOptions}
                        value={
                          Array.isArray(formData.expertise)
                            ? formData.expertise.map(Number)
                            : []
                        }
                        onChange={(selectedValues) => {
                          const numericValues = Array.from(
                            new Set((selectedValues || []).map(Number))
                          );
                          setFormData((prev) => ({
                            ...prev,
                            expertise: numericValues,
                          }));
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            expertise:
                              numericValues.length > 0
                                ? ""
                                : prevErrors.expertise,
                          }));
                        }}
                        placeholder={
                          <span
                            style={{
                              fontWeight: 600,
                              color: "#717171",
                              fontSize: "16px",
                            }}
                          >
                            Select or enter your expertise
                          </span>
                        }
                      />
                    </div>
                    <div className="form_field">
                      <FormInputs
                        type="number"
                        title="Registration Fee*"
                        placeholder="Enter Registration Fee"
                        name="registrationFee"
                        value={formData.registrationFee}
                        onChange={handleChange}
                      />
                      {errors.registrationFee && (
                        <span className="error">{errors.registrationFee}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <FormInputs
                        type="number"
                        title="Security Fee"
                        placeholder="Enter Security Fee"
                        name="securityFee"
                        value={formData.securityFee}
                        onChange={handleChange}
                      />
                      {errors.securityFee && (
                        <span className="error">{errors.securityFee}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <FormInputs
                        type="number"
                        title="Expected Per Session Fee"
                        placeholder="Enter Expected Per Session Fee"
                        name="expectedPerSessionFee"
                        value={formData.expectedPerSessionFee}
                        onChange={handleChange}
                      />
                      {errors.expectedPerSessionFee && (
                        <span className="error">
                          {errors.expectedPerSessionFee}
                        </span>
                      )}
                    </div>
                    <div className="form_field">
                      <FormInputs
                        type="number"
                        title="Approved Per Session Fee"
                        placeholder="Enter Approved Per Session Fee"
                        name="finalPerSessionFee"
                        value={formData.finalPerSessionFee}
                        onChange={handleChange}
                      />
                      {errors.finalPerSessionFee && (
                        <span className="error">
                          {errors.finalPerSessionFee}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="weekly-schedule-flex">
              <WeeklySchedule
                setSchedule={setSchedule}
                schedule={schedule}
                daylightSchedule={daylightSchedule}
                setDaylightSchedule={setDaylightSchedule}
                onDeleteSlot={handleDeleteSlot}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <Buttons variant="primary" onClick={handleUpdate}>
                Update
              </Buttons>
            </div>
          </TabPane>
          <TabPane tab="Assigned Classes" key="2">
            <Card style={{ marginTop: 24, boxShadow: "0 2px 8px #f0f1f2" }}>
              <Table
                columns={assignedClassesColumns}
                dataSource={assignedClassesData}
                pagination={{
                  current: assignedPageIndex + 1,
                  pageSize: assignedPageSize,
                  total: assignedTotal,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50"],
                  onChange: (page, size) => {
                    setAssignedPageIndex(page - 1);
                    setAssignedPageSize(size);
                  },
                }}
                scroll={{ y: 520 }} // body height
                locale={{
                  emptyText:
                    assignedClasses && assignedClasses.length === 0
                      ? "No assigned classes found"
                      : "Loading...",
                }}
                style={{ maxHeight: 600 }}
              />
            </Card>
          </TabPane>
          <TabPane tab="Bank Details" key="3">
            <Card
              style={{
                maxWidth: 700,
                marginTop: 24,
                boxShadow: "0 2px 8px #f0f1f2",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "24px",
                  marginBottom: 24,
                }}
              >
                <div className="form_field">
                  <FormInputs
                    disabled={true}
                    title="Bank Account Number"
                    placeholder={formData.bankAccountNumber || "NA"}
                    name="bankAccountNumber"
                    value={formData.bankAccountNumber}
                    style={{
                      backgroundColor: "#f5f5f5",
                      cursor: "not-allowed",
                      color: "#8c8c8c",
                    }}
                  />
                </div>
                <div className="form_field">
                  <FormInputs
                    disabled={true}
                    title="IFSC Code"
                    placeholder="NA"
                    name="ifscCode"
                    value={formData.ifscCode}
                    onChange={handleChange}
                  />
                  {errors.ifscCode && (
                    <span className="error">{errors.ifscCode}</span>
                  )}
                </div>
                <div className="form_field">
                  <FormInputs
                    disabled={true}
                    title="Bank Name & Branch Name"
                    placeholder="NA"
                    name="branchName"
                    value={formData.branchName}
                    onChange={handleChange}
                  />
                  {errors.branchName && (
                    <span className="error">{errors.branchName}</span>
                  )}
                </div>
                <div className="form_field">
                  <FormInputs
                    disabled={true}
                    title="Account Holder's Name"
                    placeholder="NA"
                    name="accountHolderName"
                    value={formData.accountHolderName}
                    onChange={handleChange}
                  />
                  {errors.accountHolderName && (
                    <span className="error">{errors.accountHolderName}</span>
                  )}
                </div>
                <div className="form_field">
                  <FormInputs
                    disabled={true}
                    title="UPI ID"
                    placeholder="NA"
                    name="upiId"
                    value={formData.upiId}
                    onChange={handleChange}
                  />
                  {errors.upiId && (
                    <span className="error">{errors.upiId}</span>
                  )}
                </div>
              </div>
            </Card>
          </TabPane>
          <TabPane tab="View Profile" key="4">
            <div className="view-profile-cards">
              <Card title="Total Bookings" style={{ marginBottom: 16 }}>
                <div style={{ display: "flex", gap: 32 }}>
                  <div>
                    <div style={{ fontWeight: 500 }}>Online</div>
                    <div style={{ fontSize: 20, fontWeight: 600 }}>
                      {profileData.totalOnlineBookings}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontWeight: 500 }}>Offline</div>
                    <div style={{ fontSize: 20, fontWeight: 600 }}>
                      {profileData.totalOfflineBookings}
                    </div>
                  </div>
                </div>
              </Card>
              <Card title="Total Earnings" style={{ marginBottom: 16 }}>
                <div style={{ display: "flex", gap: 32 }}>
                  <div>
                    <div style={{ fontWeight: 500 }}>Online</div>
                    <div style={{ fontSize: 20, fontWeight: 600 }}>
                      {formatCurrency(profileData.totalOnlineEarnings)}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontWeight: 500 }}>Offline</div>
                    <div style={{ fontSize: 20, fontWeight: 600 }}>
                      {formatCurrency(profileData.totalOfflineEarnings)}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: 16,
                    paddingTop: 16,
                    borderTop: "1px solid #f0f0f0",
                  }}
                >
                  <div style={{ fontWeight: 500 }}>Gross Earning</div>
                  <div
                    style={{ fontSize: 24, fontWeight: 700, color: "#52c41a" }}
                  >
                    {formatCurrency(profileData.totalEarnings)}
                  </div>
                </div>
              </Card>
              <Card title="Group Class" style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {getBreakdownData("Group")}
                </div>
              </Card>
              <Card title="One-on-One Class" style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {getBreakdownData("One-on-One")}
                </div>
              </Card>
              <Card title="Premium Class" style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {getBreakdownData("Premium")}
                </div>
              </Card>
              <Card title="Rescheduled Class" style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                  {getBreakdownData("Rescheduled")}
                </div>
              </Card>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default ManageInstructorForm;
